import React, { useState } from 'react';
import './SecurityCard.css';
import SetPasswordModal from './updateinfo/ChangePasswordModal';

const SecurityCard = () => {
  const token = localStorage.getItem("token");
  let provider = "";

  try {
    const payload = JSON.parse(atob(token?.split('.')[1] || ""));
    provider = payload?.provider || "";
  } catch (e) {
    provider = "";
  }

  const user = {
    hasPassword: false,
  };

  const [showPasswordModal, setShowPasswordModal] = useState(false);

  return (
    <div className="security-card">
      {/* PASSWORD SECTION */}
      <div className="security-card__section">
        <div className="security-card__title">Password</div>
        <div className="security-card__row aligned-row">
          <div className="security-card__desc">
            Update your information with a password you’re not using elsewhere, and be sure to change it regularly as well as anytime you suspect it’s been compromised.
          </div>
          <button
            className="security-card__action"
            onClick={() => setShowPasswordModal(true)}
          >
            {user.hasPassword ? 'Change' : 'Set a password'}
          </button>
        </div>
      </div>

      {/* SOCIAL SIGNUP SECTION */}
      <div className="security-card__divider" />

      <div className="security-card__section">
        <div className="security-card__row vertical-align">
          <div className="security-card__column-left">
            <div className="security-card__title">Social sign up</div>
            <div className="security-card__desc">
              Connect your account with your social media account for simple and secure sign-in.
            </div>
          </div>
          <div className="security-card__column-right">
            <div className="security-card__social-header">
              <img
                src="https://www.svgrepo.com/show/475656/google-color.svg"
                alt="Google"
                className="authpage__google-logo"
              />
              <span className="security-card__social-label">Google</span>
            </div>
            <div
              className={`security-card__social-status ${provider === 'google' ? 'connected' : 'disconnected'}`}
            >
              {provider === 'google' ? 'Connected' : 'Not connected'}
            </div>
          </div>
        </div>
      </div>

      {showPasswordModal && (
        <SetPasswordModal
          onClose={() => setShowPasswordModal(false)}
          onSave={() => setShowPasswordModal(false)}
        />
      )}
    </div>
  );
};

export default SecurityCard;
